import styles from './Avatar.module.css';

export type AvatarColor = 'l1' | 'l2' | 'l3' | 'accent';

interface AvatarProps {
  name: string;
  color: AvatarColor;
  size?: number;
  dim?: boolean;
}

const COLOR_VAR: Record<AvatarColor, string> = {
  l1: 'var(--color-l1)',
  l2: 'var(--color-l2)',
  l3: 'var(--color-l3)',
  accent: 'var(--color-accent)',
};

export function Avatar({ name, color, size = 40, dim = false }: AvatarProps) {
  const letter = name.trim().charAt(0).toUpperCase() || '?';
  return (
    <span
      className={`${styles.avatar}${dim ? ` ${styles.dim}` : ''}`}
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.44),
        background: dim ? undefined : COLOR_VAR[color],
      }}
      aria-label={name}
    >
      {letter}
    </span>
  );
}
